import { FormattedMessage } from 'react-intl'

function checkOverlay() {
  if(document.querySelector('#filter-list').classList.contains('visible')) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.removeAttribute('style')
  }
}

export const triggerFilter = (e) => {
  e.preventDefault()

  document.querySelector('#filter-list').classList.toggle('visible')

  checkOverlay()
}

export default function MobileFilterToggle({ filtersCount }) {
  window.onresize = function() {
    if(window.innerWidth >= 767) {
      document.querySelector('#filter-list').classList.remove('visible')
      checkOverlay()
    }
  }
  return (
    <a className={`results-action visible-xs ${filtersCount ? 'active' : ''}`} onClick={triggerFilter}>
      <i className='font-icons icon-filters' />
      <FormattedMessage id='filter' defaultMessage='Filter' />
      { filtersCount ? (
        <small>&nbsp;({filtersCount})</small>
      ) : '' }
    </a>
  )
}
